import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { ChartData, ChartOptions } from 'chart.js';
import { TranslateService } from '@ngx-translate/core';
import { IdpAggregateMeteringItem, MonthlyUsage } from '../../../../models/idpMeteringAggregate';
import { Bind } from 'primeng/bind';
import { UIChart } from 'primeng/chart';

@Component({
  selector: 'app-monthly-scans',
  templateUrl: './monthly-scans.component.html',
  styleUrls: ['./monthly-scans.component.scss'],
  imports: [Bind, UIChart]
})
export class MonthlyScansComponent implements OnChanges {
  private translateService = inject(TranslateService);

  @Input() meteringData: IdpAggregateMeteringItem | null = null;

  chartData: ChartData<'bar'> = {
    labels: [],
    datasets: []
  };

  chartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 0.8,
    plugins: {
      legend: {
        display: false
      }
    },
    scales: {
      y: {
        beginAtZero: true
      }
    }
  };

  /**
   *
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['meteringData'] && this.meteringData) {
      this.updateChartData();
    }
  }

  /**
   *
   */
  private updateChartData(): void {
    const chartColor = getComputedStyle(document.documentElement)
      .getPropertyValue('--p-sd-primary-blue-700')
      .trim();

    this.chartData = {
      labels: this.meteringData!.monthlyUsage!.map((item: MonthlyUsage) => item.month),
      datasets: [
        {
          label: this.translateService.instant('monthlyScans'),
          data: this.meteringData!.monthlyUsage!.map((item: MonthlyUsage) => item.pagesExtracted),
          backgroundColor: chartColor,
          barThickness: 18,
          borderRadius: 4,
          borderSkipped: 'bottom'
        }
      ]
    };
  }
}
